import * as types from '../actions/types';
import * as settings from '../settings';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { fetchTrackers } from "../actions/api";

const mapStateToProps = state => ({
  ...state.navbar,
});

const mapDispatchToProps = dispatch => ({
  fetchTrackers: () => {
    dispatch(fetchTrackers());
  },

  updateTracker: (e) => {
    dispatch({type: types.CHANGE_TRACKER, tracker: e.target.value});
  }
});

class Navbar extends Component {
  componentDidMount() {
    if (settings.IS_ROLE_USER) {
      this.props.fetchTrackers();
    }
  }

  renderAnonymous() {
    return (
      <span className="navbar-text">
        Zaloguj się aby korzystać z GPS.
      </span>
    )
  }

  renderUser() {
    const options = [];
    for (const tracker of this.props.trackers) {
      options.push(<option key={tracker.id} value={tracker.id}>{tracker.name}</option>);
    }
    return (
      <form className="form-inline">
        <div className="form-row">
          <div className="col">
            <select
              className="form-control form-control-sm"
              onChange={this.props.updateTracker}>
              {options}
            </select>
          </div>
          <div className="col">
            <select
              className="form-control form-control-sm">
              <option>Ostatnie 24 godziny</option>
            </select>
          </div>
        </div>
      </form>
    )
  }

  render() {
    return (
      <div className="gps-navbar navbar navbar-expand-md navbar-dark navbar-sticky sticky-top bg-dark shadow-sm">
        <Link className="navbar-brand" to="/gps">GPS</Link>
        <ul className="navbar-nav mr-auto">
        </ul>
        {settings.IS_ROLE_USER ? this.renderUser() : this.renderAnonymous()}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
